/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../completed.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/completed/payment-method/pix/completed.payment-method.pix.component';
import * as i3 from 'ngx-clipboard/dist/src/clipboard.directive';
import * as i4 from 'ngx-clipboard/dist/src/clipboard.service';
import * as i5 from '@ngx-translate/core/src/translate.pipe';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from 'ngx-toastr';
const styles_CompletedPaymentMethodPixComponent:any[] = [i0.styles];
export const RenderType_CompletedPaymentMethodPixComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CompletedPaymentMethodPixComponent,data:{}});
export function View_CompletedPaymentMethodPixComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'img',[['alt',
      'Pix QR-Code']],[[8,'src',4]],[[(null as any),'error']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    if (('error' === en)) {
      const pd_0:any = ((<any>_co.changeQrCodeSource($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),3,'a',[['class','btn btn-sm btn-link'],
      ['ngxClipboard','']],(null as any),[[(null as any),'cbOnSuccess'],[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,5).onClick($event.target)) !== false);
      ad = (pd_0 && ad);
    }
    if (('cbOnSuccess' === en)) {
      const pd_1:any = ((<any>_co.copied()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(5,212992,(null as any),0,i3.ClipboardDirective,
      [i4.ClipboardService,i1.Renderer],{targetElm:[0,'targetElm'],cbContent:[1,'cbContent']},
      {cbOnSuccess:'cbOnSuccess'}),(_l()(),i1.ɵted(6,(null as any),['\n    ','\n'])),
      i1.ɵpid(131072,i5.TranslatePipe,[i6.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    const currVal_1:any = '';
    const currVal_2:any = _co.paymentCode;
    _ck(_v,5,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'https://quickchart.io/qr?text=',
        _co.paymentCodeQr,'&size=250');
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,6,0,i1.ɵnov(_v,7).transform('COMPLETED.COPY_PIX_PAYMENT_CODE'));
    _ck(_v,6,0,currVal_3);
  });
}
export function View_CompletedPaymentMethodPixComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'completed-payment-method-pix',
      ([] as any[]),(null as any),(null as any),(null as any),View_CompletedPaymentMethodPixComponent_0,
      RenderType_CompletedPaymentMethodPixComponent)),i1.ɵdid(1,49152,(null as any),
      0,i2.CompletedPaymentMethodPixComponent,[i7.ToastrService,i6.TranslateService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const CompletedPaymentMethodPixComponentNgFactory:i1.ComponentFactory<i2.CompletedPaymentMethodPixComponent> = i1.ɵccf('completed-payment-method-pix',
    i2.CompletedPaymentMethodPixComponent,View_CompletedPaymentMethodPixComponent_Host_0,
    {paymentCode:'paymentCode',paymentCodeQr:'paymentCodeQr'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9jb21wbGV0ZWQvcGF5bWVudC1tZXRob2QvcGl4L2NvbXBsZXRlZC5wYXltZW50LW1ldGhvZC5waXguY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9jb21wbGV0ZWQvcGF5bWVudC1tZXRob2QvcGl4L2NvbXBsZXRlZC5wYXltZW50LW1ldGhvZC5waXguY29tcG9uZW50LnRzIiwibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmMzODk0NDYxNTU5L3NyYy9zcmMvYXBwL2NvbXBsZXRlZC9wYXltZW50LW1ldGhvZC9waXgvY29tcGxldGVkLnBheW1lbnQtbWV0aG9kLnBpeC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9jb21wbGV0ZWQvcGF5bWVudC1tZXRob2QvcGl4L2NvbXBsZXRlZC5wYXltZW50LW1ldGhvZC5waXguY29tcG9uZW50LnRzLkNvbXBsZXRlZFBheW1lbnRNZXRob2RQaXhDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aW1nIHNyYz1cImh0dHBzOi8vcXVpY2tjaGFydC5pby9xcj90ZXh0PXt7cGF5bWVudENvZGVRcn19JnNpemU9MjUwXCJcbiAgICAgYWx0PVwiUGl4IFFSLUNvZGVcIlxuICAgICAoZXJyb3IpPVwiY2hhbmdlUXJDb2RlU291cmNlKCRldmVudClcIiAvPlxuPGJyPlxuPGEgY2xhc3M9XCJidG4gYnRuLXNtIGJ0bi1saW5rXCIgbmd4Q2xpcGJvYXJkIFtjYkNvbnRlbnRdPVwicGF5bWVudENvZGVcIiAoY2JPblN1Y2Nlc3MpPVwiY29waWVkKClcIj5cbiAgICB7eydDT01QTEVURUQuQ09QWV9QSVhfUEFZTUVOVF9DT0RFJ3x0cmFuc2xhdGV9fVxuPC9hPlxuIiwiPGNvbXBsZXRlZC1wYXltZW50LW1ldGhvZC1waXg+PC9jb21wbGV0ZWQtcGF5bWVudC1tZXRob2QtcGl4PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7SUFBQTtJQUFBO0lBRUs7TUFBQTtNQUFBO0lBQUE7SUFGTDtFQUFBLGdDQUU0QywwQ0FDNUM7YUFBQTtVQUFBLDRDQUFJO01BQUEsU0FDSjtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO0lBQUE7SUFBc0U7TUFBQTtNQUFBO0lBQUE7SUFBdEU7RUFBQSx1Q0FBQTtNQUFBO01BQUEsNkJBQStGO2FBQUE7TUFFM0Y7O0lBRjJCO0lBQWE7SUFBNUMsV0FBK0IsVUFBYSxTQUE1Qzs7O0lBSks7UUFBQTtJQUFMLFdBQUssU0FBTDtJQUkrRjtJQUFBOzs7O29CQ0ovRjtNQUFBO21EQUFBLFVBQUE7TUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/$$_gendir/app/completed/payment-method/pix/completed.payment-method.pix.component.ngfactory.ts